import { useRouteError } from "react-router";

import { ErrorBoundary } from "@/modules/error-boundary";

export const RouterErrorBoundary = () => {
  const error = useRouteError();

  return <ErrorBoundary error={error} />;
};
